class ColetSizeGuide extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.querySelector('.colet-size-guide__units')?.removeAttribute('hidden');
    this.querySelector('[data-colet-size-unit-heading]')?.classList.add('visually-hidden');

    this.addEventListener('click', (event) => {
      const button = event.target instanceof Element && event.target.closest('[data-colet-size-unit]');
      if (!button || !this.contains(button)) return;
      const unit = button.dataset.coletSizeUnit;
      if (unit !== 'cm' && unit !== 'inch') return;

      this.querySelectorAll('[data-colet-size-unit]').forEach((control) => {
        control.setAttribute('aria-pressed', String(control === button));
      });
      this.querySelector('[data-colet-size-unit-heading]').textContent = button.textContent;
      this.querySelectorAll('[data-colet-size-cm]').forEach((cell) => {
        const cm = cell.dataset.coletSizeCm;
        cell.textContent = unit === 'inch' ? (Number(cm) / 2.54).toFixed(2) : cm;
      });
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('colet-size-guide')) {
  customElements.define('colet-size-guide', ColetSizeGuide);
}

class ColetSizeGuideDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.controller = new AbortController();
    const options = { signal: this.controller.signal };

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element && event.target.closest('[data-colet-size-guide-trigger]');
      if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.open(trigger);
    }, options);

    this.dialog.addEventListener('click', (event) => {
      const target = event.target;
      if (target instanceof Element && target.closest('[data-colet-size-guide-close]')) {
        this.close();
      } else if (target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
          this.close();
        }
      }
    }, options);

    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    }, options);

    this.dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const controls = [...this.dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]')]
        .filter((control) => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length);
      if (!controls.length) return;
      const index = controls.indexOf(document.activeElement);
      const next = (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
      event.preventDefault();
      controls[next].focus();
    }, options);

    this.dialog.addEventListener('close', () => {
      this.dialog.removeAttribute('data-visible');
      document.documentElement.classList.remove('colet-size-guide-open');
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }, options);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    cancelAnimationFrame(this.openFrame);
    this.controller?.abort();
    if (this.dialog?.open) {
      this.dialog.close();
      document.documentElement.classList.remove('colet-size-guide-open');
    }
  }

  open(trigger) {
    clearTimeout(this.closeTimer);
    this.trigger = trigger;
    const cartDrawer = document.querySelector('[data-colet-cart-drawer][open]');
    cartDrawer?.close?.();
    if (!this.dialog.open) this.dialog.showModal();
    document.documentElement.classList.add('colet-size-guide-open');
    this.openFrame = requestAnimationFrame(() => this.dialog.setAttribute('data-visible', ''));
  }

  close() {
    cancelAnimationFrame(this.openFrame);
    this.dialog.removeAttribute('data-visible');
    const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.dialog.close(), delay);
  }
}

if (!customElements.get('colet-size-guide-drawer')) {
  customElements.define('colet-size-guide-drawer', ColetSizeGuideDrawer);
}
